
import { defineComponent } from "vue";
import { AgGridVue } from "ag-grid-vue3"; 
import "ag-grid-community/styles/ag-grid.css"; 
import "ag-grid-community/styles/ag-theme-alpine.css"; 

import { loadPaginatedRecruitment } from "@/api/recruitments";

export default defineComponent({
  name: "recruitmenthistory", 
  props: {
    widgetClasses: String
  },
  components: {
    AgGridVue
  },
  data(){
      return { 
        loading_init: true,
        gridApi: null as any,
        itemsPerPage: 100,
        to_date : new Date().toISOString().substr(0, 10),
        from_date: new Date().toISOString().substr(0, 10),
        recruitment_length: 0,

        // Define column fields to map incoming properties precisely
        columnDefs: [
          { field: "id", headerName: "#", width: 100, cellStyle: { paddingLeft: "15px" } },
          { 
            field: "userFullname", 
            headerName: "Fullname", 
            flex: 1.5,
            // Value getter formats matching your old customized layout presentation string block
            valueGetter: (params: any) => {
              if (!params.data) return '';
              return `${params.data.usid} - ${params.data.upref} / ${params.data.packagestatus} / ${params.data.userFullname}`;
            }
          },
          { field: "dteStp", headerName: "Date", flex: 1 },
          { 
            field: "sponsorFullname", 
            headerName: "Sponsor", 
            flex: 1.5,
            valueGetter: (params: any) => {
              if (!params.data) return '';
              return `${params.data.sponsorFullname} (${params.data.spid})`;
            }
          }
        ],
        defaultColDef: {
          resizable: true
        }
      }
  },
  methods: {
    onGridReady(params: any) {
      this.gridApi = params.api;
      this.loading_init = false;

     const dataSource = {
        getRows: async (requestParams: any) => {
          try {
            // Calculate the size of the block the grid is currently requesting
            const currentBlockSize = requestParams.endRow - requestParams.startRow || this.itemsPerPage || 1;

            // Wrap in Math.floor to guarantee a clean integer page parameter representation
            const targetPage = Math.floor(requestParams.startRow / currentBlockSize) + 1;

            // Construct payload snapshot utilizing dates present at runtime execution
            let params = {
              "page" : targetPage, 
              "f" : this.from_date + " 00:00:00",
              "t" : this.to_date + " 23:59:59"
            };

            const response = await loadPaginatedRecruitment(params);
            
            const rowsThisPage = response.data.pageList || [];
            const maxServerCount = response.data.maxcount || 0;

            // Sync the items per page settings seamlessly
            if (response.data.recordsPerPage && this.itemsPerPage !== response.data.recordsPerPage) {
              this.itemsPerPage = Number(response.data.recordsPerPage);   
              if (this.gridApi && typeof this.gridApi.paginationSetPageSize === 'function') {
                this.gridApi.paginationSetPageSize(Number(response.data.recordsPerPage));
              } else if (this.gridApi && typeof this.gridApi.setGridOption === 'function') {
                this.gridApi.setGridOption('paginationPageSize', Number(response.data.recordsPerPage));
              }
            }

            this.recruitment_length = maxServerCount;
            requestParams.successCallback(rowsThisPage, maxServerCount);
          } catch (error) {
            console.error("Failed to load infinite grid data segments", error);
            requestParams.failCallback();
          }
        }
      };

      this.gridApi.setDatasource(dataSource);
    },

    recruitmentshistory() { 
      // If the grid isn't ready or mounted yet, do nothing
      if (!this.gridApi) return;
      
      // Purge cache tells AG-Grid to drop its current blocks and refetch page 1
      this.gridApi.purgeInfiniteCache();
    }
  }
});
